import { Flex } from "antd";

import { FILTER_KEYS } from "constants/table";
import Pagination from "components/Common/Pagination";

const ErrorTableFooter = ({
  filters,
  tableDataTotalCount,
  loading,
  onFiltersChange,
}) => {
  return (
    <>
      <Flex justify="end" wrap="wrap">
        <Pagination
          currentPage={filters[FILTER_KEYS.PAGE]}
          currentPageSize={filters[FILTER_KEYS.PAGE_SIZE]}
          totalCount={tableDataTotalCount}
          loading={loading}
          onChange={(page, pageSize) => {
            onFiltersChange({
              [FILTER_KEYS.PAGE]: page,
              [FILTER_KEYS.PAGE_SIZE]: pageSize,
            });
          }}
        />
      </Flex>
    </>
  );
};

export default ErrorTableFooter;
